import React from "react";
import TodoApp from "./components/TodoApp";

const App = () => {
  return (
    <div className="App">
      <TodoApp></TodoApp>
    </div>
  );
};

export default App;
